const dev = {
  apiKey: "AIzaSyD1DP2oP7raVDEQyvUmuce58R83-dLizt8",
  authDomain: "modern-force-389703.firebaseapp.com",
  projectId: "modern-force-389703",
  storageBucket: "modern-force-389703.firebasestorage.app",
  messagingSenderId: "1061256606338",
  appId: "1:1061256606338:web:f23ce5aab8894d1686fa9b",
  measurementId: "G-S73W729T0L",
};

const staging = {
  apiKey: "AIzaSyBS6lSstvJpDOoZq2QO5hwkyklKMgsEuhU",
  authDomain: "candidatetools-app-qa.firebaseapp.com",
  projectId: "candidatetools-app-qa",
  storageBucket: "candidatetools-app-qa.firebasestorage.app",
  messagingSenderId: "129582643714",
  appId: "1:129582643714:web:94d455ee92e6480556c51b",
  measurementId: "G-M3144855HH",
};

const production = {
  apiKey: "AIzaSyDQEmxVjp_sqnbXBCt55QngUKZy9mFBT5M",
  authDomain: "candidatetools-app-prod.firebaseapp.com",
  projectId: "candidatetools-app-prod",
  storageBucket: "candidatetools-app-prod.firebasestorage.app",
  messagingSenderId: "194126254542",
  appId: "1:194126254542:web:dbe897261aa55de3991b9f",
  measurementId: "G-15WSHCYXS8",
};

const firebaseConfig =
  process.env.REACT_APP_ENV === "production"
    ? production
    : process.env.REACT_APP_ENV === "staging"
    ? staging
    : dev;

export default firebaseConfig;
